import { inject, Component, Inject, TemplateRef, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DataGridView, DataGridViewCollumn } from "../../../Componente/DataGridView";
import { PopUpView } from "../../../Componente/PopUpView";
import { GeraeteEdit } from "../../Controlls/EditViews/GeraeteEdit";
import { Geraete } from "../../../Api/DcoApi/Admin/AdminClasses2";
import { FloatingButtonComponent } from "../../../Componente/floatingButton";
import { RestClient } from "../../../Api/DcoApi/Client/RestClient";
import { ToastService } from "../../../Akte/Services/Toasts/ToastService";



@Component({
  imports: [
    CommonModule,
    FormsModule,
    DataGridView,
    DataGridViewCollumn,
    GeraeteEdit, PopUpView, FloatingButtonComponent
  ],
  selector: 'Geraet',
  templateUrl: './Geraet.html',
  standalone: true,
  styleUrl: './Geraet.css'
})
export class Geraet {
  @ViewChild('Grid') childComponent!: DataGridView<Geraete>;
  toastService: ToastService;
  @ViewChild('successTpl') public successTpl!: TemplateRef<any>;//#successDelTpl
  @ViewChild('successDelTpl') public successDelTpl!: TemplateRef<any>;//#FailDelTpl
  @ViewChild('FailDelTpl') public FailDelTpl!: TemplateRef<any>;

  constructor() {
    this.toastService = inject(ToastService)
  }

  triggerReload() {
    // Call the child component's function safely
    this.childComponent.LoadData();
  }

  Client: RestClient = new RestClient();

  async UploadData() {
    const input = document.createElement('input');
    input.type = 'file';

    // Event-Handler, wenn die Datei ausgewählt wurde
    input.onchange = async (event: any) => {
      await this.Client.PostFile<any>(`/GeraeteApi`, event.target.files[0]);
      this.childComponent.LoadData();
      this.toastService.show({ template: this.successTpl, classname: 'bg-success text-light show', delay: 10000 })
    };

    // Öffnet den Datei-Dialog des Betriebssystems
    input.click();

  }

  DeaktivatedDevice(device:any)
  {
    if(device.deactivated)
      return "deactivated";

    return "";
  }

  async Delete(key: any) {
    try {
      await this.Client.Delete(`/Backend/Api/V2/Admin/Geraete/${key}`);
      this.childComponent.LoadData();
      this.toastService.show({ template: this.successDelTpl, classname: 'bg-success text-light show', delay: 10000 })
    }
    catch {
      this.toastService.show({ template: this.FailDelTpl, classname: 'bg-danger text-light show', delay: 10000 })
    }
  }
}
